module.exports = __webpack_public_path__ + "img/about.involvement.partner.asset.f79bcf4d.jpg";